function conditionalCall(conditionalFlagGetter, trulyCall, falselyCall) {
    return (arg) => (conditionalFlagGetter() ? trulyCall(arg) : falselyCall(arg));
}

export { conditionalCall };
